export default __webpack_public_path__ + "static/media/Ies_MesasCruzadas_Mark_ACCESO.1443862c.jpg";